<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">New Subscription</h4>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row flex-row">

              <div class="col-sm-6">
                <form class="form-horizontal">
                  <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
                    <label for="name" class="col-sm-5 control-label">Name</label>
                    <div class="col-sm-7">
                      <input type="text" class="form-control" id="name" placeholder="Optional" v-model="name">
                      <span class="help-block" v-if="errors.name">{{ errors.name }}</span>
                    </div>
                  </div>
                  <div class="form-group" v-bind:class="{ 'has-error': errors.frequency }">
                    <label for="frequency" class="col-sm-5 control-label">Frequency</label>
                    <div class="col-sm-7">
                      <select class="form-control" id="frequency" v-model="frequency">
                        <option value="ALL" :selected="frequency === 'ALL'">Instantly</option>
                        <option value="DAILY" :selected="frequency === 'DAILY'">Daily</option>
                        <option value="WEEKLY" :selected="frequency === 'WEEKLY'">Weekly</option>
                        <option value="MONTHLY" :selected="frequency === 'MONTHLY'">Monthly</option>
                      </select>
                      <span class="help-block" v-if="errors.frequency">{{ errors.frequency }}</span>
                    </div>
                  </div>
                  <div class="form-group" v-bind:class="{ 'has-error': errors.emails }">
                    <label for="emails" class="col-sm-5 control-label">Send to</label>
                    <div class="col-sm-7">
                      <multiselect id="emails" placeholder="Add email" v-model="emails" :options="emailsOptions" :limit="10"
                                   :multiple="true" :taggable="true" :closeOnSelect="false" :showLabels="false" @tag="tagEmailConverter">
                      </multiselect>
                      <span class="help-block" v-if="errors.emails">{{ errors.emails }}</span>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-sm-6">
                <div class="form-group" v-bind:class="{ 'has-error': errors.area }">
                  <label for="lmap">Geographic area</label>
                  <div id="lmap">
                  </div>
                  <span class="help-block" v-if="errors.area">{{ errors.area }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="create" v-if="!isUpdate">Create</button>
          <button type="button" class="btn btn-primary" @click="update" v-if="isUpdate">Update</button>
          <button type="button" class="btn btn-danger" @click="remove" v-if="isUpdate">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Multiselect from 'vue-multiselect'
  import api from '../../api'

  const leafletURL = '/static/js/plugins/leaflet/leaflet.js'
  const leafletAreaURL = '/static/js/plugins/leaflet/leaflet-areaselect.js'

  let map
  let areaSelect

  export default {
    name: 'SubscriptionModal',
    components: {Multiselect},
    data () {
      return {
        isUpdate: false,
        subscriptionForUpdate: null,
        name: null,
        frequency: null,
        emails: [],
        emailsOptions: [],
        area: {
          center: null,
          northEast: null,
          southWest: null,
          zoom: null,
          size: null
        },
        errors: {
          name: null,
          frequency: null,
          emails: null,
          area: null
        }
      }
    },
    methods: {
      init (subscription) {
        this.isUpdate = !!subscription
        this.editedSubscription = _.cloneDeep(subscription)

        this.name = subscription ? subscription.name : null
        this.frequency = subscription ? subscription.frequency : null
        this.emails = subscription ? _.clone(subscription.emails) : []
        this.emailsOptions = subscription ? _.clone(subscription.emails) : []
        this.area = subscription ? _.clone(subscription.area) : {
          center: null,
          northEast: null,
          southWest: null,
          zoom: null,
          size: null
        }
      },
      initMap () {
        const that = this

        window.jQuery.getScript(leafletURL, () => {
          window.jQuery.getScript(leafletAreaURL, () => {
            const L = window.L
            const domTargetID = 'lmap'

            if (map && L.DomUtil.get(domTargetID).hasChildNodes()) {
              // Redraw if already initialized
              map.invalidateSize()
            } else {
              map = L.map(domTargetID, {
                maxBounds: L.latLngBounds([[-90, -360], [90, 360]]),
                worldCopyJump: true,
                minZoom: 1
              })
            }

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
              maxZoom: 18
            }).addTo(map)

            if (areaSelect) {
              areaSelect.off('change')
              areaSelect.remove()
            }

            if (that.isUpdate) {
              map.setView(L.latLng(that.area.center[1], that.area.center[0]), that.area.zoom)
              areaSelect = L.areaSelect({
                width: that.area.size[0],
                height: that.area.size[1],
                keepAspectRatio: false
              })
            } else {
              map.setView([45, 0], 1)
              areaSelect = L.areaSelect({
                width: 450,
                height: 300,
                keepAspectRatio: false
              })
            }

            areaSelect.on('change', function () {
              const bounds = this.getBounds()
              const center = map.getCenter()
              that.area = {
                center: [center.lng, center.lat],
                northEast: [bounds._northEast.lng, bounds._northEast.lat],
                southWest: [bounds._southWest.lng, bounds._southWest.lat],
                zoom: map.getZoom(),
                size: [areaSelect._width, areaSelect._height]
              }
            })

            areaSelect.addTo(map)
          })
        })
      },
      create () {
        this.clearErrors()
        if (!this.preValidate()) {
          return
        }

        api.authenticatedRequest('POST', '/notifications', {
          name: this.name,
          emails: this.emails,
          frequency: this.frequency,
          area: this.area
        })
          .then(() => this.close())
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      update () {
        this.clearErrors()
        if (!this.preValidate()) {
          return
        }

        const data = {}
        if (!_.isEqual(this.name, this.editedSubscription.name)) {
          data.name = this.name
        }
        if (!_.isEqual(this.emails, this.editedSubscription.emails)) {
          data.emails = this.emails
        }
        if (!_.isEqual(this.frequency, this.editedSubscription.frequency)) {
          data.frequency = this.frequency
        }
        if (!_.isEqual(this.area.northEast, this.editedSubscription.area.northEast) && !_.isEqual(this.area.southWest, this.editedSubscription.area.southWest)) {
          data.area = this.area
        }

        if (_.keys(data).length) {
          api.authenticatedRequest('PUT', `/notifications/${this.editedSubscription._id}`, data)
            .then(() => this.close())
            .catch(error => {
              console.log(error)
              if (error.response.status === 401) { // InvalidCredentialsError
                this.response = 'Username/Password incorrect. Please try again.'
                return
              }
              this.response = 'Server appears to be offline'
            })
        } else {
          this.close()
        }
      },
      remove () {
        this.$emit('remove', this.editedSubscription._id)
      },
      clearErrors () {
        this.errors = {
          name: null,
          frequency: null,
          emails: null,
          area: null
        }
      },
      preValidate () {
        this.normalizeCoordinates()

        const validFrequency = !_.isNil(this.frequency)
        const validEmails = !_.isEmpty(this.emails)
        const validArea = this.isValidLongitude(this.area.northEast[0]) && this.isValidLongitude(this.area.southWest[0]) &&
          this.isValidLatitude(this.area.northEast[1]) && this.isValidLatitude(this.area.southWest[1])

        if (!validFrequency) {
          this.errors.frequency = 'The frequency must be specified'
        }
        if (!validEmails) {
          this.errors.emails = 'At least one email must be specified'
        }
        if (!validArea) {
          this.errors.area = 'Area coordinates are not valid'
        }

        // true if no errors, false otherwise
        return !_.compact(_.values(this.errors)).length
      },
      normalizeCoordinates () {
        // Ensure longitude is always between -180 and 180
        if (this.area.northEast[0] > 180.0) {
          this.area.northEast[0] -= 360.0
        }

        if (this.area.southWest[0] < -180.0) {
          this.area.southWest[0] += 360.0
        }
      },
      isValidLongitude (lng) {
        return _.isNumber(lng) && lng >= -180.0 && lng <= 180.0
      },
      isValidLatitude (lat) {
        return _.isNumber(lat) && lat >= -90.0 && lat <= 90.0
      },
      tagEmailConverter (name) {
        if (name && name.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          this.emails.push(name)
          this.emailsOptions.push(name)
        }
      },
      close () {
        this.$emit('close')
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.init()
      })
    }
  }
</script>

<style>
  @import "/static/css/leaflet/leaflet.css";
  @import "/static/css/leaflet/leaflet-areaselect.css";

  #lmap {
    height: 400px;
  }

  .flex-row {
    display: flex;
  }

  .flex-row > [class^='col-'] {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// SubscriptionModal.vue?fda1d9e4